import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyInput, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const CurrentCumulativeAmount = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="suspiciousActivityInfo.currentCumulativeAmount"
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="31. Current Cumulative" input={(props) => <CurrencyInput {...props} disabled />} />
      )}
    />
  )
}
